<template>
  <div id="B">qqqqqq</div>
</template>

<script>
export default {
  name: "B",
  created() {},
  mounted() {
    upsdk.pluginReady(function () {
      upsdk.registerLifecycle({
        onPageBack: function () {
          // 点击返回按钮
          upsdk.showFlashInfo({
            msg: "点击返回按钮",
          });
        },
      });

      upsdk.setTitleStyle({
        // 可选，导航栏(含状态栏)背景色及透明度。16进制，前2位(8F)透明度，后六位(FFFFFF)颜色，仅对当前页有效，其余页还是申请配置的导航默认颜色。
        navBackgroundColor: "0x8FFFFFFF",
        appletStyle: "black", //可选，black-黑色主题，white-白色主题。
        backBtnVisible: "0", // 可选，左侧返回按钮是否显示。’0’不显示，’1’显示，不传或空则默认显示
        appletTitleBarVisible: "1", // 可选，标题栏是否显示。’0’不显示，’1’显示，默认显示
      });
    });

  },
};
</script>

<style>
#app {
  min-width: 320px;
  max-width: 480px;
  margin: 0 auto;
}
</style>


// WEBPACK FOOTER //
// CloudWeApp.vue?107a26d4